import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { PropertyDocumentType } from '@workspace/data-types';
import { DialogLayoutAuraComponent } from '@workspace/ng-aura';

export interface PropertyDocumentRejectDialogData {
  documentName?: string;
  documentType?: PropertyDocumentType;
  currentReason?: string;
}

@Component({
  selector: 'etxe-property-document-reject-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    DialogLayoutAuraComponent,
  ],
  templateUrl: './property-document-reject-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDocumentRejectDialogComponent {
  readonly dialogRef = inject(MatDialogRef<PropertyDocumentRejectDialogComponent>);
  readonly data: PropertyDocumentRejectDialogData = inject(MAT_DIALOG_DATA) || {};

  readonly presetReasons: string[] = [
    'Document illisible ou flou',
    'Nom ou informations ne correspondant pas au propriétaire',
    'Document incomplet (pages manquantes)',
    'Document expiré ou caduc',
    'Mauvais type de document téléversé',
  ];

  selectedPreset = signal<string>(this.data.currentReason || this.presetReasons[0]);
  reasonText = signal<string>(this.data.currentReason || this.presetReasons[0]);

  selectPreset(preset: string): void {
    this.selectedPreset.set(preset);
    this.reasonText.set(preset);
  }

  selectCustom(): void {
    this.selectedPreset.set('other');
    this.reasonText.set('');
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    const trimmed = this.reasonText().trim();
    if (!trimmed) return;
    this.dialogRef.close(trimmed);
  }
}
